/**
 * DashboardScreen — S0 Dashboard
 * canonical: lines 578–721
 *
 * Renders inside V3Shell (which provides .shell > .sb + .main > .content).
 * This component fills .main > .content with:
 *   DashboardTopBar  (canonical lines 599–605)
 *   .pc wrapper      (canonical line 606)
 *   DashboardKpis    (canonical lines 608–629)
 *   ActiveProjectsTable (canonical lines 631–665)
 */

import { useState } from 'react'
import { DashboardTopBar }      from './DashboardTopBar'
import { DashboardKpis }        from './DashboardKpis'
import { ActiveProjectsTable }  from './ActiveProjectsTable'
import DashboardDrillDownPanel, { type DrillDownView } from './DashboardDrillDownPanel'

/** canonical: S0 — lines 578–721 */
export function DashboardScreen() {
  const [drillDown, setDrillDown] = useState<DrillDownView | null>(null)

  return (
    <>
      <DashboardTopBar />

      <div className="pc">
        <DashboardKpis onDrillDown={setDrillDown} />
        <ActiveProjectsTable />
      </div>

      <DashboardDrillDownPanel view={drillDown} onClose={() => setDrillDown(null)} />
    </>
  )
}
